<div
  class="media-slot"
  [class.media-slot--clickable]="mode !== 'placeholder' || true"
  [style.height]="height"
  [style.background-color]="mode === 'placeholder' ? '#f4f4f4' : 'transparent'"
  [style.cursor]="'pointer'"
  [attr.role]="mode === 'placeholder' || mode === 'video' ? 'button' : null"
  tabindex="0"
  [attr.aria-label]="ariaLabel"
  (click)="onClick()"
  (keydown)="onKeydown($event)"
>
  <!-- Image mode -->
  <img
    *ngIf="mode === 'image' && src"
    [src]="src"
    [style.width]="'100%'"
    [style.height]="height"
    style="object-fit: cover; display: block;"
    alt="media"
  />

  <!-- Video mode: play overlay only (no inline <video>) -->
  <div
    *ngIf="mode === 'video'"
    class="media-slot_play"
    aria-hidden="true"
  >
    <span class="media-slot_play-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
        <path d="M8 5v14l11-7z" />
      </svg>
    </span>
  </div>

  <!-- Placeholder mode: gray rect (no icon, no click feedback) -->
</div>
